import { render } from "./ItmInquiry.vue?vue&type=template&id=7880df3b&scoped=true"
import script from "./ItmInquiry.vue?vue&type=script&lang=js"
export * from "./ItmInquiry.vue?vue&type=script&lang=js"

import "./ItmInquiry.vue?vue&type=style&index=0&id=7880df3b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7880df3b"]])

export default __exports__